import { Box, FormLabel } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { EditListService, GetListByIdService } from "../../../../Services/GetProspectsPosts";
import { Controller, useForm } from "react-hook-form";
import { PrimaryButton, SecondaryButton } from "../../ReusableComponents/StyledButton";
import AddUpdate from "../../ReusableComponents/AddUpdate";
import { StyledTextField } from "../../ReusableComponents/StyledTextField";
import toast from "react-hot-toast";
import StyledSpinner from "../../ReusableComponents/StyledSpinner";
import { useNurtureContext } from "../../../../Context/NurtureContext";

const PAGE_TITLE = "Edit your list details";

const styles = {
  Btn: {
    display: "flex",
    alignItems: "center",
    gap: "0.5rem",
    fontSize: "16px",
    color: "var(--color-primary)",
    fontWeight: "600",
    background: "none",
    border: "none",
    margin: "0",
  },
  Title: {
    fontSize: "16px",
    color: "var(--color-primary)",
    fontWeight: "700",
    marginInline: "auto",
  },
  FormBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
  },
  Form: {
    maxWidth: "420px",
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
    marginBottom: "4rem",
  },
  FormGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    marginBottom: "1rem",
  },
  FormLabel: {
    fontSize: "16px",
    color: "#1E1E1E",
    fontWeight: "600",
    lineHeight: "20px",
    fontFamily: "Poppins",
    margin: "0",
    "&.Mui-focused": {
      color: "#000",
    },
  },
  FormBtn: {
    fontSize: "14px",
    width: "167px",
    height: "40px",
  },
};

function UpdateList() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [listData, setListData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const { setRefreshListsKey, setRefreshProspectsKey } = useNurtureContext();
  const inputSx = {
    "&": { borderColor: "#E6E9EC" },
    "&, & > div": { color: "#000000" },
    "& input": { color: "#000000" },
    "& input::placeholder": { color: "#000000", opacity: 1 },
    "& .MuiSelect-select": { color: "#000000" },
    "& svg": { color: "#000000" },
  };

  const initialFormData = {
    ...listData,
    title: listData?.title ?? "",
  };

  const {
    control,
    handleSubmit,
    formState: { errors, isDirty },
  } = useForm({
    defaultValues: initialFormData,
    values: initialFormData,
  });

  const onSubmit = async (editData) => {
    try {
      setIsLoading(true);
      const obj = {
        listId: id,
        listData: {
          ...listData,
          ...editData,
          email_notification: "Off",
          days_to_scrape: [],
          day: null,
          hour: listData?.hour ?? "8am",
          timezone: listData?.timezone ?? 120,
          time_to_scrape: listData?.time_to_scrape ?? "12am",
        },
      };
      delete obj.listData["number_of_prospects_in_list"];
      const res = await EditListService(obj);
      if (res.status === 200) {
        setRefreshListsKey((oladKey) => oladKey + 1);
        setRefreshProspectsKey((oladKey) => oladKey + 1);
        toast.success("List updated successfully");
        navigate(-1);
      } else {
        throw new Error("Something went wrong");
      }
    } catch (err) {
      toast.error("Something went wrong");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!id) return;
    GetListByIdService(id).then((res) => {
      res.json().then((json) => {
        setListData(json.data[0]);
      });
    });
  }, [id]);

  return (
    <AddUpdate ressource="lists" title={PAGE_TITLE}>
      <StyledSpinner isLoading={isLoading} />
      <form style={styles.Form} onSubmit={handleSubmit(onSubmit)}>
        <Box sx={styles.FormGroup}>
          <FormLabel sx={styles.FormLabel} htmlFor="title">
            List Name
          </FormLabel>
          <Controller
            name="title"
            control={control}
            rules={{ required: "Please provide a list name." }}
            render={({ field }) => (
              <StyledTextField
                {...field}
                color="#000000"
                variant="standard"
                height="50px"
                error={!!errors?.title}
                helperText={errors?.title?.message}
                placeholder="List #1"
                sx={inputSx}
                InputProps={{
                  disableUnderline: true,
                }}
              />
            )}
          />
        </Box>
        <Box display="flex" justifyContent="center" gap="1rem" mt="2rem">
          <PrimaryButton disabled={!isDirty} type="submit" sx={styles.FormBtn}>
            Save
          </PrimaryButton>
          <SecondaryButton onClick={() => navigate(-1)} sx={styles.FormBtn}>
            Cancel
          </SecondaryButton>
        </Box>
      </form>
    </AddUpdate>
  );
}

export default UpdateList;
